/**
 * Basic feature detection checks.
 */

const capabilities = {
  modernBrowser: 'visibilityState' in document,
  // liteMode: false,
  trackingConsent: navigator.doNotTrack,
};

module.exports = capabilities;
